export function showLoader(name, config = {}) {
  return {
    type: 'SHOW_LOADER',
    name,
    config
  };
}

export function hideLoader(name) {
  return {
    type: 'HIDE_LOADER',
    name
  };
}
